__webpack_require__.p = "/czech-cases-practice/";